import { useRef, useEffect, useState } from "react";

/**
 * Bir tablo veya yatay kaydırılabilir içeriği sarar.
 * Yatay taşma varsa "position: sticky; bottom: 0" bir ayna scrollbar gösterir;
 * taşma yoksa gizler.
 */
export function StickyScrollWrapper({ children, className = "" }) {
  const scrollRef = useRef(null);
  const mirrorRef = useRef(null);
  const innerRef  = useRef(null);
  const syncing   = useRef(false);
  const [needsScroll, setNeedsScroll] = useState(false);

  useEffect(() => {
    const el     = scrollRef.current;
    const mirror = mirrorRef.current;
    const inner  = innerRef.current;
    if (!el || !mirror || !inner) return;

    const updateSize = () => {
      const has = el.scrollWidth > el.clientWidth + 2;
      setNeedsScroll(has);
      inner.style.width = el.scrollWidth + "px";
    };

    const onElScroll = () => {
      if (syncing.current) return;
      syncing.current = true;
      mirror.scrollLeft = el.scrollLeft;
      requestAnimationFrame(() => { syncing.current = false; });
    };

    const onMirrorScroll = () => {
      if (syncing.current) return;
      syncing.current = true;
      el.scrollLeft = mirror.scrollLeft;
      requestAnimationFrame(() => { syncing.current = false; });
    };

    el.addEventListener("scroll", onElScroll, { passive: true });
    mirror.addEventListener("scroll", onMirrorScroll, { passive: true });

    const ro = new ResizeObserver(updateSize);
    ro.observe(el);
    updateSize();

    return () => {
      el.removeEventListener("scroll", onElScroll);
      mirror.removeEventListener("scroll", onMirrorScroll);
      ro.disconnect();
    };
  }, []);

  return (
    <div className={`relative ${className}`}>
      <div ref={scrollRef} className="overflow-x-auto overflow-y-visible">
        {children}
      </div>
      {/* Yapışkan ayna scrollbar — sadece taşma varsa görünür */}
      <div
        ref={mirrorRef}
        style={{
          position: "sticky",
          bottom: 0,
          overflowX: "auto",
          overflowY: "hidden",
          height: needsScroll ? 14 : 0,
          transition: "height 0.15s ease",
          zIndex: 5,
          background: "var(--zen-bg, #0C1220)",
        }}
      >
        <div ref={innerRef} style={{ height: 1 }} />
      </div>
    </div>
  );
}
